import { isAndroid, isHarmony, isIos } from "./utils";

const sdicHomeEmit = (eventName: string, params: any = {}) => {
  if (typeof params === "undefined") {
    params = {};
  }

  if (typeof params.onCallback === "function") {
    const fnName = `cb${Date.now()}${Math.random().toString(36).substring(2)}`;

    (window as any)[fnName] = (...rest: any) => {
      params.onCallback.apply(null, rest);
      delete (window as any)[fnName];
    };

    params.__callback__ = fnName;
  }

  // ios
  if (isIos()) {
    const data = {
      method: "sdicHomeApp_" + eventName,
      dataDic: JSON.stringify(params),
    };
    if (
      typeof (window as any).webkit?.messageHandlers?.sdicHomeWebViewJS.postMessage === "function"
    ) {
      (window as any).webkit.messageHandlers.sdicHomeWebViewJS.postMessage(data);
    } else {
      console.error("webkit.messageHandlers.sdicHomeWebViewJS.postMessage is not function");
    }
    return;
  }
  if (isHarmony()) {
    // 鸿蒙
    const gkey = "sdicHomeApp_" + eventName;
    if (typeof (window as any).sdicHomeJavascriptInterface?.[gkey] === "function") {
      (window as any).sdicHomeJavascriptInterface[gkey](JSON.stringify(params));
    } else {
      console.error(`${gkey} 协议不存在，或APP的版本较低`);
    }
    return;
  }
  if (isAndroid()) {
    // android
    const gkey = "sdicHomeApp_" + eventName;
    if (typeof (window as any).APPMETHOD?.[gkey] === "function") {
      (window as any).APPMETHOD[gkey](JSON.stringify(params));
    } else {
      console.error(`${gkey} 协议不存在，或APP的版本较低`);
    }
    return;
  }
  console.error(`不支持当前操作系统`);
};

export default sdicHomeEmit;
